// label: 'blog', 'presentation', 'community'

const EXPERIENCES = [
  {
    id: "if-kakao-mfe",
    detailDescription:
      "if(kakao)25 krew day에서 카카오클라우드의 MFE 도입 배경과 과정, 도입 후 얻은 결과를 발표하였습니다.",
    images: [
      {
        src: "/images/experiences/if-kakao-mfe/01-presentation.webp",
        caption: "if(kakao)25 krew day 발표 현장",
        alt: "if(kakao)25 krew day에서 카카오클라우드의 MFE 도입 경험을 발표하는 모습",
      },
    ],
    date: "2025. 09. 25",
    title: "프론트엔드 쪼개기 - 카카오클라우드의 MFE 이야기",
    description:
      "if(kakao)25 krew day 행사에서 발표를 진행했습니다. 카카오클라우드의 MFE 도입 배경과 과정, 그리고 얻은 결과물을 공유하였습니다.",
    link: "https://tech.kakao.com/posts/793",
    label: "presentation",
  },

  {
    date: "2025. 05. 30",
    title: "Module Federation으로 알아보는 Micro Front-end",
    id: "module-federation-blog",
    detailDescription:
      "Module Federation을 중심으로 Micro Front-end의 개념과 구성 방식을 소개한 글입니다. 쇼핑몰과 배달 관리 서비스 예시로 독립 배포, 공통 영역 공유, 서비스 간 화면 전환 방식을 설명하였습니다. 개발 환경과 공유 의존성 관리, 서버 사이드 적용 시 고려할 점과 글 작성 당시의 생태계 동향도 함께 정리하였습니다.",
    images: [
      {
        src: "/images/experiences/module-federation-blog/01-mfe-overview.webp",
        caption: "MFE 포스팅 썸네일",
        alt: "MFE 훑어보기: Module Federation으로 알아보는 Micro Front-End 표지",
      },
      {
        src: "/images/experiences/module-federation-blog/02-screen-composition.webp",
        caption: "포스팅 내용 중 예시 일부",
        alt: "배달 관리, 대시보드, 가게 관리 화면을 공통 화면 영역에 결합하는 MFE 구성 예시",
      },
    ],
    description:
      "MFE의 개념과 상세한 사례를 소개하는 글입니다. 고려할 사항과 생태계 동향까지 다루고 있습니다.",
    link: "https://haesoo9410.tistory.com/411",
    label: "blog",
  },

  {
    date: "2024. 03. 27",
    title: "Frontend-DevOps: 모던 프론트엔드의 역할",
    id: "frontend-devops",
    detailDescription:
      "프론트엔드의 규모와 구조가 복잡해지면서 개발자가 배포와 운영에도 참여해야 하는 이유를 정리한 글입니다. 의존성 관리, CI/CD, 모니터링 등 필요한 역량을 살펴보고, 배포 속도 개선과 장애 대응, 협업 방식 개선을 가상 사례로 설명하였습니다. UI 개발을 넘어 서비스의 성능과 안정성까지 살피는 프론트엔드 개발자의 역할을 다루었습니다.",
    images: [
      {
        src: "/images/experiences/frontend-devops/01-fe-devops-map.webp",
        caption: "FE DevOps 포스팅 썸네일",
        alt: "프론트엔드 DevOps의 생산성, 성능, 안정화 영역과 관련 기술을 정리한 마인드맵",
      },
    ],
    description:
      "Frontend-DevOps가 필요해진 배경과 그 역할에 대해 소개하는 글입니다. 필요성과 사례를 자세히 설명하였습니다.",
    link: "https://haesoo9410.tistory.com/408",
    label: "blog",
  },

  {
    date: "2023. 08. 09",
    title: "Next.js13으로 알아보는 FE렌더링",
    id: "nextjs-rendering",
    detailDescription:
      "AWSKRUG 프론트엔드 행사에서 FE 렌더링 방식의 변화 과정을 소개하고, SSR과 RSC를 직접 구현하며 비교한 내용을 발표하였습니다.",
    images: [
      {
        src: "/images/experiences/nextjs-rendering/01-presentation.webp",
        caption: "AWSKRUG 프론트엔드 발표 현장",
        alt: "AWSKRUG 프론트엔드 행사에서 프론트엔드 렌더링 방식의 변화를 설명하는 발표 장면",
      },
      {
        src: "/images/experiences/nextjs-rendering/02-event.webp",
        caption: "AWSKRUG 프론트엔드 행사 전경",
        alt: "Next.js13으로 알아보는 FE렌더링 발표자와 참석자들이 함께 보이는 행사 전경",
      },
    ],
    description:
      "AWSKRUG 프론트엔드 행사에서 발표를 진행했습니다. FE 렌더링 방식의 변화과정을 소개하였고, SSR과 RSC를 직접 만들며 비교하였습니다.",
    link: "https://haesoo9410.tistory.com/405",
    label: "presentation",
  },

  {
    date: "2023. 04. 26",
    title: "전공과 다른 길을 걷게 되기까지",
    id: "career-seminar",
    detailDescription:
      "모교 단과대학의 취업진로세미나에서 개발자 직무를 선택하게 된 과정을 소개하고, 취업 준비의 방향을 제안하는 특강을 진행하였습니다.",
    images: [
      {
        src: "/images/experiences/career-seminar/01-title.webp",
        caption: "취업진로세미나 발표 표지",
        alt: "전공과 다른 길을 걷게 되기까지: 2023년 1학기 취업진로세미나 발표 표지",
      },
      {
        src: "/images/experiences/career-seminar/02-seminar.webp",
        caption: "취업진로세미나 특강 현장",
        alt: "강의실에서 진행된 취업진로세미나의 강연 현장과 참석 학생들",
      },
    ],
    description:
      "모교 단과대학에서 진행한 취업진로세미나의 특강발표입니다. 개발자 직무를 선택하게된 과정을 소개하고, 취업 준비 과정의 방향성을 제시하였습니다.",
    link: "https://haesoo9410.tistory.com/389",
    label: "presentation",
  },

  {
    date: "2023. 06. 09",
    title: "BFF 개발 시의 고려요소",
    id: "bff-blog",
    detailDescription:
      "BFF를 개발할 때 고려해야 할 데이터 통신, 보안, 성능 최적화와 배포를 정리한 글입니다. API 병렬 호출과 응답 가공, 인증과 접근 제어, 캐싱 등 각 영역의 구현 방법과 고려사항을 설명하였습니다. 프론트엔드 팀이 BFF를 독립적으로 개발하고 운영하기 위해 필요한 테스트·배포·모니터링 과정도 함께 다루었습니다.",
    images: [
      {
        src: "/images/experiences/bff-blog/01-cover.webp",
        caption: "BFF 포스팅 썸네일",
        alt: "다리 사진을 배경으로 한 BFF 개발 시의 고려요소 글 표지",
      },
      {
        src: "/images/experiences/bff-blog/02-architecture.webp",
        caption: "포스팅 내용 중 BFF 구조 예시",
        alt: "여러 서버의 API를 데스크톱과 모바일용 BFF에 연결하는 구조도",
      },
    ],
    description:
      "BFF를 개발하면서 고려해야할 사항들을 정리한 글입니다. BFF의 개념과 구현 시 고려해야할 사항들을 다루고 있습니다.",
    link: "https://haesoo9410.tistory.com/388?category=974679",
    label: "blog",
  },

  {
    id: "song-ku-hae-hyeon",
    title: "스터디 그룹: 송구해현",
    date: "2021. 10 - Present",
    label: "community",
    description:
      "스터디원들과 함께 ‘송구해현’ 스터디 그룹을 운영하고 있습니다. 분기마다 주제를 바꾸며 소프트웨어 분야의 다양한 기술과 지식을 함께 학습하고 있습니다.",
    detailDescription: "현재까지 다음 주제들을 학습하였습니다.",
    detailTopics: [
      {
        id: "game-development",
        title: "Game Development",
        date: "26.06–26.09",
        description:
          "게임 개발에 쓰이는 패턴과 게임 기획 이론을 학습하였습니다. 이를 활용해 스터디원 각자가 게임을 제작하고 js13kGames 게임잼에 출품하였습니다.",
      },
      {
        id: "large-scale-services",
        title: "Large-Scale Services",
        date: "26.02–26.05",
        description:
          "『대규모 서비스를 지탱하는 기술』을 읽고 대용량 데이터 처리와 서버 인프라를 학습하였습니다. 캐시와 데이터베이스 분산, 부하 분산과 다중화 등 서비스의 확장성과 안정성을 확보하는 방법을 공부하였습니다.",
      },
      {
        id: "ai-agents",
        title: "AI Agents",
        date: "25.10–26.01",
        description:
          "『요즘 AI 에이전트 개발』을 읽고 LLM과 RAG의 기초부터 멀티 에이전트 개발까지 학습하였습니다. 직접 에이전트를 만들며 도구 활용과 협업 방식, MCP와 A2A를 이용한 연동 방법을 익혔습니다.",
      },
      {
        id: "software-engineering",
        title: "Software Engineering",
        date: "25.05–25.08",
        description:
          "『소프트웨어 엔지니어 가이드북』을 읽고 개발자의 경력 단계별 역할과 필요한 역량을 학습하였습니다. 개발과 협업에 필요한 마인드셋과 커리어를 관리하는 방법을 배웠습니다.",
      },
      {
        id: "unit-test",
        title: "Unit Test",
        date: "25.01–25.04",
        description:
          "단위 테스트 작성과 목·스텁을 이용한 의존성 분리 방법을 학습하였습니다. 신뢰할 수 있고 읽기 쉬우며 유지보수하기 좋은 테스트를 작성하는 원칙을 익혔습니다.",
      },
      {
        id: "technical-writing",
        title: "Technical Writing",
        date: "24.11–25.01",
        description:
          "Google의 Technical Writing 교육 자료를 바탕으로 명확하고 간결한 기술 문서 작성법을 학습하였습니다.",
      },
      {
        id: "docker",
        title: "Docker",
        date: "24.06–24.11",
        description:
          "도커와 컨테이너의 기본 개념을 학습하고, 실습으로 사용법을 익혔습니다. 쿠버네티스의 기본 개념도 함께 공부하였습니다.",
      },
      {
        id: "design-pattern",
        title: "Design Pattern",
        date: "24.01–24.06",
        description:
          "22가지 디자인 패턴을 학습하고 TypeScript로 직접 구현하였습니다. 스터디원들과 각 패턴을 적용할 수 있는 사례를 함께 논의하였습니다.",
      },
      {
        id: "chrome-extension",
        title: "Chrome Extension",
        date: "23.01–24.01",
        description:
          "크롬 확장 앱의 구조와 개발 방법을 학습하고, 스터디원들과 Breaking the Browser를 개발하였습니다. 브라우저 화면 위에 그림을 그리거나 다양한 효과를 적용하는 기능을 구현하고 크롬 웹 스토어에 배포하였습니다.",
      },
      {
        id: "haskell",
        title: "Haskell",
        date: "22.07–23.11",
        description:
          "Haskell을 통해 함수형 프로그래밍의 개념과 코드를 작성하는 방식을 학습하였습니다.",
      },
      {
        id: "effective-typescript",
        title: "Effective TypeScript",
        date: "22.03–22.06",
        description:
          "타입 시스템과 타입 추론, 타입 설계 원칙을 학습하였습니다. 타입스크립트를 안전하고 효과적으로 사용하는 방법을 익혔습니다.",
      },
      {
        id: "js-and-web",
        title: "JS and Web",
        date: "21.10–22.02",
        description:
          "클로저와 프로토타입, 모듈 시스템 등 자바스크립트의 동작 원리를 학습하였습니다. 브라우저 렌더링과 저장소, 쿠키·세션·JWT 등 웹의 기본 개념도 함께 정리하였습니다.",
      },
    ],
    images: [
      {
        src: "/images/experiences/song-ku-hae-hyeon/01-study-group.webp",
        alt: "민트색 배경에 Study with Song Ku Hae Hyeon 문구가 적힌 스터디 그룹 소개 이미지",
        caption: "송구해현 스터디 그룹 대표 이미지",
      },
    ],
    link: "https://song-ku-hae-hyeon.github.io/tech-logs/",
  },

  {
    id: "ai-sprint-pbl-mentor",
    title: "네이버 커넥트 AI 스프린트 멘토",
    date: "26.06-26.07",
    label: "community",
    description:
      "부산대학교에서 진행된 AI 스프린트 PBL에 멘토로 참여하여, 학생들이 2주간 기획부터 개발·검증까지 경험하도록 도왔습니다. 매일 온라인으로 프로젝트 진행 상황을 살피고 기획과 개발 협업, AI 활용을 조언했으며, 마지막 날에는 오프라인 데모데이에서 발표를 보고 피드백했습니다.",
    detailDescription:
      "네이버 커넥트재단이 주최한 AI 스프린트 PBL에 부산대학교 멘토로 참여했습니다. 1주차는 기획, 2주차는 개발을 중심으로 진행하며, 학생들이 바이브 코딩을 활용해 2주 안에 기획부터 개발·검증까지 경험하도록 도왔습니다. 매일 온라인으로 만나 프로젝트 진행 상황을 살피고 조언했으며, 프로젝트 외의 다양한 질문에도 답했습니다.\n\n기획 단계에서는 실제 현업에서 개발에 앞서 검토하는 사항을 함께 살펴보고, 프로토타입을 그리며 아이디어를 구체화하도록 도왔습니다. 학생들은 개발을 시작하기 전에 고려해야 할 사항이 많다는 것을 체감하고 협업을 경험했습니다. 개발 단계에서는 GitHub 활용법과 개발 협업 시 고려할 점을 안내했습니다. AI에 질문하는 데서 나아가 스킬을 활용하고, GitHub와 Figma 같은 도구에서도 AI의 도움을 받는 방법을 소개했습니다.\n\n마지막 날에는 오프라인 데모데이에 참여해 담당 팀뿐 아니라 다른 팀의 발표도 보고 피드백했습니다.",
    images: [
      {
        src: "/images/experiences/ai-sprint-pbl-mentor/01-program.webp",
        caption: "AI 스프린트 PBL 프로그램 대표 이미지",
        alt: "연두색 배경에 중급 교과형 AI 스프린트 PBL 제목과 NAVER CONNECT 큐브가 있는 프로그램 이미지",
      },
      {
        src: "/images/experiences/ai-sprint-pbl-mentor/02-vibe-coding.webp",
        caption: "현직 개발자와 함께하는 바이브 코딩 프로그램 안내",
        alt: "NAVER 로고 아래 현직 개발자와 함께하는 바이브코딩 문구가 있는 안내 이미지",
      },
      {
        src: "/images/experiences/ai-sprint-pbl-mentor/03-bootcamp.webp",
        caption: "부산대학교 AI 분야 첨단산업 인재양성 부트캠프 안내",
        alt: "교육부, KIAT, 부산광역시, 부산대학교 로고와 AI 분야 첨단산업 인재양성 부트캠프 제목",
      },
      {
        src: "/images/experiences/ai-sprint-pbl-mentor/04-curriculum.webp",
        caption: "AI 스프린트 PBL 교육 일정과 단계별 프로젝트 과정",
        alt: "6월 29일부터 7월 9일까지 온라인 교육과 7월 10일 오프라인 최종 발표 일정, 문제 정의부터 설계·개발·발표까지 단계별 과정을 정리한 안내문",
      },
    ],
  },

  {
    date: "2024. 09 - 2024. 12",
    title: "네이버 부스트캠프 웹 9기 멘토",
    id: "boostcamp-mentor",
    detailDescription:
      "네이버 부스트캠프 웹 9기에서 코드 리뷰와 프로젝트 리뷰 멘토로 활동하였습니다.",
    images: [
      {
        src: "/images/experiences/boostcamp-mentor/01-boostcamp.webp",
        caption: "부스트캠프 웹·모바일 9기 대표 이미지",
        alt: "네이버 커넥트 부스트캠프 웹·모바일 9기 대표 이미지",
      },
    ],
    description:
      "네이버 부스트캠프 웹 9기 멘토로 참여하였습니다. 코드 리뷰와 프로젝트 리뷰 멘토로 활동하였습니다.",
    label: "community",
  },

  {
    date: "2024. 08 - 2024. 10",
    title: "취업 멘토링을 위한 개발자 밋업 데이",
    id: "meetup-mentor",
    detailDescription:
      "점핏이 주최한 개발자 밋업 데이에서 취업 멘토로 참여하여 전라권·충청권·수도권 훈련생을 대상으로 각 지역에서 멘토링을 진행하였습니다.",
    images: [
      {
        src: "/images/experiences/meetup-mentor/01-event-entrance.webp",
        caption: "개발자 밋업 데이 행사 배너 (서울)",
        alt: "개발자 밋업 데이 행사장 입구의 안내 배너",
      },
      {
        src: "/images/experiences/meetup-mentor/02-event-banner.webp",
        caption: "개발자 밋업 데이 행사 현수막 (대전)",
        alt: "개발자 밋업 데이 행사장 내부에 설치된 현수막",
      },
    ],
    description:
      "점핏의 밋업 데이 행사에서 취업 멘토로 참여했습니다. 전라권, 충청권, 수도권 훈련생을 대상으로 각 지역에서 멘토링을 진행하였습니다.",
    label: "community",
  },

  {
    date: "2023. 08. 18",
    title: "실전 직무탐색 프로그램",
    id: "career-exploration",
    detailDescription:
      "동국대학교 실전 직무탐색 프로그램에 취업 멘토로 참여하여, IT 회사와 직무에 관심 있는 학생들에게 취업 과정을 소개하였습니다.",
    images: [
      {
        src: "/images/experiences/career-exploration/01-title.webp",
        caption: "실전 직무탐색 프로그램 발표 표지",
        alt: "IT 회사 입사하기: 동국대학교 실전 직무탐색 프로그램 발표 표지",
      },
    ],
    description:
      "동국대학교 취업 멘토로 참여하여 발표하였습니다. IT 회사와 직무에 관심이 있는 학생들에게 취업과정에 대해 소개하였습니다.",
    label: "community",
  },
];

export default EXPERIENCES;
